<div [ngSwitch]="state">
  <span class="badge text-bg-penalizado shade" *ngSwitchCase="'Penalty'"><span i18n>Penalizado</span> <i class="bi bi-x"></i></span>
  <span class="badge text-bg-autorizado shade" *ngSwitchCase="'Registered'"><span i18n>Autorizado</span> <i class="bi bi-check"></i></span>
  <span class="badge text-bg-permitido shade" *ngSwitchCase="'Not registered'"><span i18n>Permitido</span> <i class="bi bi-check"></i></span>
</div>